import { render, staticRenderFns } from "./surrender.vue?vue&type=template&id=8667bb0a&scoped=true&"
import script from "./surrender.vue?vue&type=script&lang=js&"
export * from "./surrender.vue?vue&type=script&lang=js&"
import style0 from "./surrender.vue?vue&type=style&index=0&id=8667bb0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667bb0a",
  null
  
)

export default component.exports